module.exports = __webpack_public_path__ + "static/media/worley.948d9847.png";